// Capture UTM/referrer attribution into sessionStorage on first hit so the
// lead-capture forms can include it on submission.
const KEY = "aara_attribution";

export function captureAttribution() {
  try {
    if (typeof window === "undefined") return;
    const existing = sessionStorage.getItem(KEY);
    if (existing) return;
    const params = new URLSearchParams(window.location.search);
    const utm = {
      utm_source: params.get("utm_source") || null,
      utm_medium: params.get("utm_medium") || null,
      utm_campaign: params.get("utm_campaign") || null,
      utm_term: params.get("utm_term") || null,
      utm_content: params.get("utm_content") || null,
      referrer: document.referrer || null,
    };
    sessionStorage.setItem(KEY, JSON.stringify(utm));
  } catch (err) {
    console.error("Attribution capture failed:", err);
  }
}

export function getAttribution() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (err) {
    console.error("Attribution read failed:", err);
    return {};
  }
}
